import { RAG } from 'features/dashboard/charts/scoreColour'

export const TASK_STATUS_OPTIONS = [
  { value: 'unassigned',              label: 'Unassigned' },
  { value: 'assigned',                label: 'Assigned' },
  { value: 'in_progress',             label: 'In progress' },
  { value: 'pending_dependent',       label: 'Waiting on dependency' },
  { value: 'visited_awaiting_report', label: 'Visited, awaiting report' },
  { value: 'contractor_rescheduled',  label: 'Contractor rescheduled (approved)' },
  { value: 'waiting_remedial',        label: 'Waiting on remedial' },
  { value: 'on_hold',                 label: 'On hold' },
  { value: 'awaiting_approval',       label: 'Pending approval' },
  { value: 'completed',               label: 'Completed' },
]

// The single source of truth for task-status colour: every status maps to a
// RAG level, and the colour comes from the one shared RAG map (scoreColour).
const STATUS_RAG_LEVEL = {
  unassigned:              'none',
  assigned:                'medium',
  in_progress:             'medium',
  pending_dependent:       'medium',
  visited_awaiting_report: 'medium',
  contractor_rescheduled:  'medium',
  awaiting_approval:       'medium',
  on_hold:                 'medium',
  waiting_remedial:        'critical',
  overdue:                 'critical',
  completed:               'low',
}

export const TASK_STATUS_LABEL = Object.fromEntries(
  TASK_STATUS_OPTIONS.map(o => [o.value, o.label])
)

export const taskStatusLabel = value =>
  (value === 'overdue' ? 'Overdue' : (TASK_STATUS_LABEL[value] || value))

export const taskStatusRag = value => RAG[STATUS_RAG_LEVEL[value] || 'none']

export const taskStatusTint = value => taskStatusRag(value).fg

export const taskStatusMeta = value => {
  const rag = taskStatusRag(value)
  return { label: taskStatusLabel(value), color: rag.fg, bg: rag.bg }
}

export const TASK_STATUS_TINT = Object.fromEntries(
  Object.keys(STATUS_RAG_LEVEL).map(k => [k, taskStatusRag(k).fg])
)
